import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-2" }

import InfoModalBtnArea from '@/components/AccountParts/InfoModalBtnArea.vue';
import InfoModal from "@/components/Common/InfoModal.vue"
import { computed } from 'vue'
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'RoleAssignInfoModal',
  props: {
    modelValue: { type: Boolean },
    roleAssignAuthority: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props;

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InfoModal, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
    modalWidth: "30%"
  }, {
    text: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("h4", null, _toDisplayString(_unref(i18n).global.t('pages.accounts.InfoModal.infoMessagesRow1')), 1),
        _createElementVNode("h4", _hoisted_1, _toDisplayString(_unref(i18n).global.t('pages.accounts.InfoModal.infoMessagesRow2')), 1)
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(InfoModalBtnArea, {
        roleAssignAuthority: props.roleAssignAuthority
      }, null, 8, ["roleAssignAuthority"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})